import React, { useState, useEffect } from 'react';
import Tabs from './Tabs';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import Sidebar from './Sidebar';
import Loader from '../../atoms/loader';
import PerformanceSection from './PerformanceChart';
import './budget-dashboard-widget.m.css';

const BudgetDashboardWidget = () => {
  const queryClient = new QueryClient();
  const dashboardData = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'budget', 'budget_dashboard_widget'], []),
  );
  const [tabs, setTabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [apiEndpoint, setApiEndpoint] = useState(null);
  const [isHindi, seIsHindi] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');

    let darkModeEnabled = false;

    if (dm === '1') {
      // Force dark mode ON
      darkModeEnabled = true;
    } else if (disabledm === '1') {
      // Force dark mode OFF
      darkModeEnabled = false;
    } else {
      // Use system preference
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      darkModeEnabled = mediaQuery.matches;
    }
    setIsDarkMode(darkModeEnabled);

    // Set background color
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = darkModeEnabled ? '#234046' : '#FFFFFF';
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const isKhabarSite = params.get('site') === 'khabar';
    seIsHindi(isKhabarSite);

    const endpoint = isKhabarSite ? dashboardData?.endpoint_hindi : dashboardData?.endpoint;

    setApiEndpoint(endpoint);
  }, [dashboardData?.endpoint, dashboardData?.endpoint_hindi]);

  /* ---------------- API CALL ---------------- */
  useEffect(() => {
    if (!apiEndpoint) return;

    const fetchDashboardData = async () => {
      try {
        const res = await fetch(apiEndpoint);
        const jsonFile = await res.json();
        setTabs(jsonFile?.tabs || []);
      } catch (error) {
        console.error('Dashboard API error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [apiEndpoint]);

  /* reset sidebar when tab changes */
  useEffect(() => {
    setActiveItemIndex(0);
  }, [activeTabIndex]);

  const activeTab = tabs[activeTabIndex];
  const hasSidebar = activeTab?.data?.length > 1;
  const activeItem = activeTab?.data?.[activeItemIndex] || activeTab?.data?.[0];

  if (loading) {
    return (
      <div styleName={`loader-container ${isDarkMode ? 'dark' : ''}`}>
        <Loader />
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <div styleName={`dashboard ${isDarkMode ? 'dark' : ''}`}>
        <Tabs
          tabs={tabs}
          activeIndex={activeTabIndex}
          onChange={setActiveTabIndex}
          darkMode={isDarkMode}
        />
        <div styleName={`dashboard-body ${!hasSidebar ? 'full-width' : ''}`}>
          {hasSidebar && (
            <Sidebar
              items={activeTab.data}
              activeIndex={activeItemIndex}
              onChange={setActiveItemIndex}
              darkMode={isDarkMode}
            />
          )}
          <PerformanceSection
            data={activeItem}
            pmKisanList={dashboardData.pm_kisan}
            isHindi={isHindi}
            darkMode={isDarkMode}
          />
        </div>
      </div>
    </QueryClientProvider>
  );
};

export default BudgetDashboardWidget;
